import { ReactNode } from "react";

import { cn } from "@/lib/utils";

export interface CellContainerProps {
  children: ReactNode;
  isSelected?: boolean;
  borderColor?: string;
  className?: string;
}

export const CellContainer = ({
  children,
  isSelected = false,
  borderColor = "border-gray-200",
  className = "",
}: CellContainerProps) => (
  <div
    className={cn(
      "flex w-full flex-1 flex-col border-r transition-colors duration-200",
      borderColor,
      isSelected
        ? "!bg-blue-50 group-hover:!bg-blue-100 [&>div]:border-blue-500 [&>div]:!bg-blue-50 [&>div]:group-hover:!bg-blue-100"
        : "",
      className,
    )}
  >
    {children}
  </div>
);
